import { Navigate, useRoutes } from "react-router-dom";
// errors pages
import CompactLayout from "src/layouts/compact/CompactLayout";
import Page404 from "src/pages/Page404";
// auth
import AuthGuard from "src/auth/AuthGuard";
import "src/index.css";
import GuestGuard from "../auth/GuestGuard";
import DashboardLayout from "../layouts/dashboard";
// config
//
import ForbesCustomDashboardPage from "src/pages/dashboard/custom/forbes-custom-dashboard-page";
import MediumCustomDashboardPage from "src/pages/dashboard/custom/medium-custom-dashboard-page";
import MercuryNewsCustomDashboardPage from "src/pages/dashboard/custom/mercury-news-custom-dashboard-page";
import NYCTimesCustomDashboardPage from "src/pages/dashboard/custom/nyc-times-custom-dashboard-page";
import QuartzCustomDashboardPage from "src/pages/dashboard/custom/quartz-custom-dashboard-page";
import TwitterCustomDashboardPage from "src/pages/dashboard/custom/twitter-custom-dashboard-page";
import YoutubeCustomDashboardPage from "src/pages/dashboard/custom/youtube-custom-dashboard-page";
import ForbesMainDashboardPage from "src/pages/dashboard/main/forbes-main-dashboard-page";
import MediumMainDashboardPage from "src/pages/dashboard/main/medium-main-dashboard-page";
import MercuryMainDashboardPage from "src/pages/dashboard/main/mercury-news-main-dashboard-page";
import NYCTimesMainDashboardPage from "src/pages/dashboard/main/nyc-times-main-dashboard-page";
import QuartzMainDashboardPage from "src/pages/dashboard/main/quartz-main-dashboard-page";
import TwitterMainDashboardPage from "src/pages/dashboard/main/twitter-main-dashboard-page";
import YoutubeMainDashboardPage from "src/pages/dashboard/main/youtube-main-dashboard-page";
import {
  LoginPage,
  // Auth
  RegisterPage,
} from "./elements";
import { paths } from "./paths";
// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: "/",
      element: <Navigate to={paths.main.youtube} />,
    },
    // Auth
    {
      path: "auth",
      children: [
        {
          path: "login",
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
        {
          path: "register",
          element: (
            <GuestGuard>
              <RegisterPage />
            </GuestGuard>
          ),
        },
      ],
    },

    // Main Dashboard
    {
      path: paths.main.root,
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        // Main dashboard - Social media
        {
          path: paths.main.youtube,
          element: <YoutubeMainDashboardPage />,
        },
        {
          path: paths.main.twitter,
          element: <TwitterMainDashboardPage />,
        },
        // Main dashboard - Newspaper
        {
          path: paths.main.medium,
          element: <MediumMainDashboardPage />,
        },
        {
          path: paths.main.forbes,
          element: <ForbesMainDashboardPage />,
        },
        {
          path: paths.main.quartz,
          element: <QuartzMainDashboardPage />,
        },
        {
          path: paths.main.NYCTimes,
          element: <NYCTimesMainDashboardPage />,
        },
        {
          path: paths.main.TheMercuryNews,
          element: <MercuryMainDashboardPage />,
        },
      ],
    },

    {
      path: paths.custom.root,
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: paths.custom.youtube(),
          element: <YoutubeCustomDashboardPage />,
        },
        {
          path: paths.custom.twitter(),
          element: <TwitterCustomDashboardPage />,
        },
        {
          path: paths.custom.medium(),
          element: <MediumCustomDashboardPage />,
        },
        {
          path: paths.custom["mercury_news"](),
          element: <MercuryNewsCustomDashboardPage />,
        },
        {
          path: paths.custom.forbes(),
          element: <ForbesCustomDashboardPage />,
        },
        {
          path: paths.custom.nyc_times(),
          element: <NYCTimesCustomDashboardPage />,
        },
        {
          path: paths.custom.quartz(),
          element: <QuartzCustomDashboardPage />,
        },
      ],
    },

    {
      element: <CompactLayout />,
      children: [{ path: "404", element: <Page404 /> }],
    },

    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
